// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box no-print">
  <div command-access-context="\$ctrl.commandAccessContext(\$ctrl.selectedAccount)">

    <sub-header header="'Deposit accounts'">
      <div class="right-header-panel" ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'">
        <div class="switch">
          <input id="closed-table-switch"
                 type="checkbox"
                 ng-model="\$ctrl.showClosed"
                 ng-change="\$ctrl.toggleClosedAccounts()"
                 ng-disabled="\$ctrl.onlyClosedDeposits()"/>
          <label for="closed-table-switch">Show closed accounts</label>
        </div>
        <button class="btn btn-primary"
                command-access="CreateAccount"
                ng-click="\$ctrl.createNew()">Create new</button>
      </div>
    </sub-header>

    <customer-nongroup-access ng-if="\$ctrl.profile.status && \$ctrl.profile.status !== 'CLOSED'"></customer-nongroup-access>

    <form-section>
      <div class="container--with-mini-menu">

        <div>
          <table class="table" at-table at-list="\$ctrl.visibleAccounts">
            <thead></thead>
            <tbody class="tbody">
            <tr ng-click="\$ctrl.selectAccount(item)"
                ng-class="{'selected': item == \$ctrl.selectedAccount}"
                class="table__row--clickable">
              <td at-title="No">
                {{\$index+1}}
              </td>
              <td at-attribute="productName" at-title="Product name">{{item.productName}}</td>
              <td at-attribute="subtype" at-title="Account subtype">{{item.subtype | prettyEnum}}</td>
              <td at-title="Account number">
                {{\$ctrl.formatProductAndExtraNumber(item)}}
              </td>
              <td at-attribute="status" at-title="Status">{{item.status | prettyEnum}}</td>
              <td at-title="Total balance">
                <span ng-class="{'currency--positive': (item.balance + item.holdsBalance) > 0, 'currency--negative': (item.balance + item.holdsBalance) < 0}">
                  {{item.balance + item.holdsBalance | nxCurrency}}
                </span>
              </td>
              <td at-title="Available balance">
                <span ng-class="{'currency--positive': item.balance > 0, 'currency--negative': item.balance < 0}">
                  {{item.balance | nxCurrency}}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mini-menu right-details" ng-if="\$ctrl.selectedAccount">
          <ul class="nav-tabs">
            <li class="active"><a data-target="#operations" data-toggle="tab">Operations</a></li>
            <li><a data-target="#details" data-toggle="tab">Details</a></li>
            <li><a data-target="#owners" data-toggle="tab">{{\$ctrl.isCorporate ? "Signatories" : "Owners"}}</a></li>
            <li ng-if="\$ctrl.selectedAccount.subtype !== 'SAVINGS'"><a data-target="#ata" data-toggle="tab">ATA</a></li>
            <li ng-if="\$ctrl.selectedAccount.type.automaticDebitAgreementEnabled"><a data-target="#ada" data-toggle="tab">ADA</a></li>
            <li command-access="ConfigureAutoBalanceSweep"
                ng-if="\$ctrl.isAutoSweepFacilityEnabled">
              <a data-target="#sweep" data-toggle="tab">Sweep</a>
            </li>
            <li ng-if="\$ctrl.selectedAccount.supportsGroup">
              <a data-target="#group" data-toggle="tab">Group</a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="operations">
              <div class="operation-row">
                <button class="btn"
                        type="button"
                        command-access="DepositCashToAccount"
                        ng-class="{'btn-success': \$ctrl.cashDepositAvailable(), 'btn-default': !\$ctrl.cashDepositAvailable()}"
                        ng-click="\$ctrl.cashDeposit()"
                        ng-disabled="!\$ctrl.cashDepositAvailable()">
                  Cash Deposit
                </button>
                <div class="btn-group" command-access="DepositCheckToAccount, DepositMultipleChecksToAccount">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          ng-class="{'btn-success': \$ctrl.checkDepositAvailable(), 'btn-default': !\$ctrl.checkDepositAvailable()}"
                          ng-disabled="!\$ctrl.checkDepositAvailable()">
                    Check Deposit
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="DepositCheckToAccount">
                      <a ng-click="\$ctrl.checkDeposit()">
                        Single check
                      </a>
                    </li>
                    <li command-access="DepositMultipleChecksToAccount">
                      <a ng-click="\$ctrl.multipleChecksDeposit()">
                        Multiple checks
                      </a>
                    </li>
                  </ul>
                </div>
                <button class="btn"
                        type="button"
                        command-access="DepositMemoToAccount"
                        ng-class="{'btn-success': \$ctrl.creditMemoAvailable(), 'btn-default': !\$ctrl.creditMemoAvailable()}"
                        ng-click="\$ctrl.creditMemo()"
                        ng-disabled="!\$ctrl.creditMemoAvailable()">
                  Credit Memo
                </button>
                <button class="btn"
                        type="button"
                        command-access="ActivateAccount"
                        ng-class="{'btn-success': \$ctrl.activationAvailable(), 'btn-default': !\$ctrl.activationAvailable()}"
                        ng-click="\$ctrl.activateAccount()"
                        ng-disabled="!\$ctrl.activationAvailable()">
                  Activate account
                </button>

                <!-- Display cash withdrawal & check withdrawal buttons only for SAVINGS/COMBO accounts -->
                <button class="btn"
                        type="button"
                        command-access="WithdrawAccountFundsByCash"
                        ng-if="\$ctrl.selectedAccount.subtype !== 'CHECKING'"
                        ng-class="{'btn-danger': \$ctrl.cashWithdrawalAvailable(), 'btn-default': !\$ctrl.cashWithdrawalAvailable()}"
                        ng-click="\$ctrl.cashWithdraw()"
                        ng-disabled="!\$ctrl.cashWithdrawalAvailable()">
                  Cash Withdr.
                </button>
                <button class="btn"
                        type="button"
                        command-access="WithdrawAccountFundsByCheck"
                        ng-if="\$ctrl.selectedAccount.subtype !== 'CHECKING'"
                        ng-class="{'btn-danger': \$ctrl.checkWithdrawalAvailable(), 'btn-default': !\$ctrl.checkWithdrawalAvailable()}"
                        ng-click="\$ctrl.checkWithdrawal()"
                        ng-disabled="!\$ctrl.checkWithdrawalAvailable()">
                  Check Withdr.
                </button>

                <!-- Display check encashment button only for NON-SAVINGS accounts -->
                <button class="btn"
                        type="button"
                        command-access="EncashOnUsCheck"
                        ng-if="\$ctrl.selectedAccount.subtype !== 'SAVINGS'"
                        ng-class="{'btn-danger': \$ctrl.encashOnUsCheckAvailable(), 'btn-default': !\$ctrl.encashOnUsCheckAvailable()}"
                        ng-click="\$ctrl.encashCheck()"
                        ng-disabled="!\$ctrl.encashOnUsCheckAvailable()">
                  Encash check
                </button>

                <!-- Display debit memo button for all types of accounts -->
                <button class="btn"
                        type="button"
                        command-access="WithdrawAccountFundsByMemo"
                        ng-class="{'btn-danger': \$ctrl.debitMemoAvailable(), 'btn-default': !\$ctrl.debitMemoAvailable()}"
                        ng-click="\$ctrl.debitMemo()"
                        ng-disabled="!\$ctrl.debitMemoAvailable()">
                  Debit Memo
                </button>

                <!-- Display ATM cash withdrawal for all types of accounts -->
                <button class="btn"
                        type="button"
                        command-access="AccountTransferToProduct"
                        ng-click="\$ctrl.transferToProduct()"
                        ng-class="{'btn-danger': \$ctrl.accountTransferToProductAvailable(), 'btn-default': !\$ctrl.accountTransferToProductAvailable()}"
                        ng-disabled="!\$ctrl.accountTransferToProductAvailable()">
                  Transfer to product
                </button>
                <button class="btn"
                        type="button"
                        command-access="PesonetOverTheCounterTransfer"
                        ng-click="\$ctrl.pesonetTransfer()"
                        ng-class="{'btn-danger': \$ctrl.externalTransferAvailable(), 'btn-default': !\$ctrl.externalTransferAvailable()}"
                        ng-disabled="!\$ctrl.externalTransferAvailable()">
                  PESONet transfer
                </button>
                <button class="btn"
                        type="button"
                        command-access="OutgoingInstapayTransfer"
                        ng-click="\$ctrl.instapayTransfer()"
                        ng-class="{'btn-danger': \$ctrl.externalTransferAvailable(), 'btn-default': !\$ctrl.externalTransferAvailable()}"
                        ng-disabled="!\$ctrl.externalTransferAvailable()">
                  InstaPay transfer
                </button>
                <div class="btn-group"
                     command-access="CloseZeroBalanceAccount, CloseAccountWithCash, CloseAccountWithCheck, CloseAccountWithEncash">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          ng-class="{'btn-danger': \$ctrl.closingAvailable(), 'btn-default': !\$ctrl.closingAvailable()}"
                          ng-disabled="!\$ctrl.closingAvailable()">
                    Close <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="CloseZeroBalanceAccount" ng-if="\$ctrl.selectedAccount.balance + \$ctrl.selectedAccount.holdsBalance === 0">
                      <a ng-click="\$ctrl.closeZeroBalance()">
                        Close
                      </a>
                    </li>
                    <li command-access="CloseAccountWithCash" ng-if="\$ctrl.selectedAccount.subtype !== 'CHECKING' && \$ctrl.selectedAccount.status === 'ACTIVE'">
                      <a ng-click="\$ctrl.closeAccountCash()">
                        Close With Cash
                      </a>
                    </li>
                    <li command-access="CloseAccountWithCheck" ng-if="\$ctrl.selectedAccount.status === 'ACTIVE'">
                      <a ng-click="\$ctrl.closeAccountCheck()">
                        Close With Check
                      </a>
                    </li>
                    <li command-access="CloseAccountWithEncash" ng-if="\$ctrl.selectedAccount.subtype !== 'SAVINGS' && \$ctrl.selectedAccount.status === 'ACTIVE'">
                      <a ng-click="\$ctrl.closeAccountCheckEncash()">
                        Close With Check Encashment
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="btn-group"
                     command-access="UpdateAccount, UpdateAccountSignatureCard, UpdateAccountFeeSharing">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          ng-disabled="!\$ctrl.editAvailable()"
                          ng-class="{'btn-warning': \$ctrl.editAvailable(), 'btn-default': !\$ctrl.editAvailable()}">
                    Edit <span class="caret">
                  </span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="UpdateAccount"><a ng-click="\$ctrl.edit()">Edit parameters</a></li>
                    <li command-access="UpdateAccountSignatureCard"><a ng-click="\$ctrl.editSignatureCard()">Edit signature card</a></li>
                    <li command-access="UpdateAccountCollector" ng-if="\$ctrl.selectedAccount.type.allowCenterManagement"><a ng-click="\$ctrl.editCollector()">Edit collector</a></li>
                    <li command-access="ChangeAccountType" ng-if="\$ctrl.canChangeAccountType()"><a ng-click="\$ctrl.changeAccountType()">Change account type</a></li>
                    <li command-access="UpdateAccountFeeSharing" ng-if="\$ctrl.permissions['ACC_FEE_SHARING_WRITE']"><a ng-click="\$ctrl.editFeeSharing()">Edit fee sharing</a></li>
                  </ul>
                </div>

                <signature-card
                  file-id="\$ctrl.selectedAccount.signatureCardFileId"
                  product-group="'ACCOUNT'"
                  product-status="\$ctrl.selectedAccount.status"></signature-card>
                <button class="btn btn-primary"
                        command-access="ReopenAccount"
                        ng-if="\$ctrl.selectedAccount.status == 'CLOSED' && !\$ctrl.releaseLockAvailable()"
                        ng-click="\$ctrl.reopenAccount()">
                  Reopen account
                </button>
                <div class="btn-group" command-access="CreditOnUsCheck, BatchCreditOnUsCheck">
                  <button class="btn dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          ng-class="{'btn-success': \$ctrl.creditOnUsCheckAvailable(), 'btn-default': !\$ctrl.creditOnUsCheckAvailable()}"
                          ng-disabled="!\$ctrl.creditOnUsCheckAvailable()">
                    Credit On-us Check
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li command-access="CreditOnUsCheck">
                      <a ng-click="\$ctrl.creditOnUsCheck()">
                        Single check
                      </a>
                    </li>
                    <li command-access="BatchCreditOnUsCheck">
                      <a ng-click="\$ctrl.batchCreditOnUsChecks()">
                        Multiple checks
                      </a>
                    </li>
                  </ul>
                </div>
                <button class="btn"
                        type="button"
                        command-access="CreateCheckStopOrder"
                        ng-class="{'btn-danger': \$ctrl.createStopOrderAvailable(), 'btn-default': !\$ctrl.createStopOrderAvailable()}"
                        ng-click="\$ctrl.createStopOrder()"
                        ng-disabled="!\$ctrl.createStopOrderAvailable()">
                  Create Stop Order
                </button>
                <button class="btn"
                        type="button"
                        command-access="CreateDepositAccountPassbook"
                        ng-class="{'btn-warning': \$ctrl.passbookIssueAvailable(), 'btn-default': !\$ctrl.passbookAvailable()}"
                        ng-click="\$ctrl.issuePassbook()"
                        ng-disabled="!\$ctrl.passbookIssueAvailable()">
                  Issue Passbook
                </button>

                <button class="btn"
                        type="button"
                        command-access="CreateCheckbook"
                        ng-class="{'btn-warning': \$ctrl.checkbookIssueAvailable(), 'btn-default': !\$ctrl.checkbookIssueAvailable()}"
                        ng-click="\$ctrl.issueCheckbook()"
                        ng-disabled="!\$ctrl.checkbookIssueAvailable()">
                  Issue Checkbook
                </button>
                <button class="btn"
                        type="button"
                        command-access="CreateManualHold"
                        ng-class="{'btn-danger': \$ctrl.createHoldAvailable(), 'btn-default': !\$ctrl.createHoldAvailable()}"
                        ng-click="\$ctrl.createHold()"
                        ng-disabled="!\$ctrl.createHoldAvailable()">
                  Create Hold
                </button>
                <button class="btn"
                        type="button"
                        command-access="CreateProductLock"
                        ng-class="{'btn-danger': \$ctrl.createLockAvailable(), 'btn-default': !\$ctrl.createLockAvailable()}"
                        ng-click="\$ctrl.createLock()"
                        ng-disabled="!\$ctrl.createLockAvailable()">
                  Create Lock
                </button>
                <button class="btn"
                        type="button"
                        command-access="BatchReleaseProductLock"
                        ng-class="{'btn-success': \$ctrl.releaseLockAvailable(), 'btn-default': !\$ctrl.releaseLockAvailable()}"
                        ng-click="\$ctrl.releaseLock()"
                        ng-disabled="!\$ctrl.releaseLockAvailable()">
                  Release Locks
                </button>
                <button class="btn"
                        type="button"
                        command-access="CreateAccountAlias"
                        ng-class="'btn-success'"
                        ng-click="\$ctrl.createAlias()"
                        ng-if="\$ctrl.isCorporate && !\$ctrl.selectedAccount.alias && \$ctrl.selectedAccount.status !== 'CLOSED'">
                  Create Alias
                </button>
              </div>
            </div>

            <div class="tab-pane" id="details">
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">CIF Name:</span>
                  <span class="value">{{\$ctrl.profile.effectiveName}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Address:</span>
                  <span class="value">{{(\$ctrl.profile.primaryAddress | prettyAddress) || '-'}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.hasActivePassbook()">
                  <span class="key">Passbook No.:</span>
                  <span class="value">{{\$ctrl.activePassbook.number || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Status:</span>
                  <span class="value"
                        data-status="{{\$ctrl.selectedAccount.status}}">{{\$ctrl.selectedAccount.status}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Created on:</span>
                  <span class="value">{{\$ctrl.selectedAccount.createdOn | prettyDate}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedAccount.closedOn">
                  <span class="key">Closed on:</span>
                  <span class="value">{{\$ctrl.selectedAccount.closedOn | prettyDate}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Created in branch:</span>
                  <span class="value">{{\$ctrl.selectedAccount.branchName}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Casa class code:</span>
                  <span class="value">{{\$ctrl.selectedAccount.casaClassCode | prettyEnum}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">ADB Interest:</span>
                  <span class="value">{{\$ctrl.selectedAccount.adbInterest | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">ADB Monthly:</span>
                  <span class="value">{{\$ctrl.selectedAccount.adbMonthly | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">ADB Last 90 days:</span>
                  <span class="value">{{\$ctrl.selectedAccount.adbLast90Days | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Uncleared deposit:</span>
                  <span class="value">{{\$ctrl.selectedAccount.totalUnclearedCheckDepositAmount | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last customer transaction:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.lastCustomerTransaction | prettyDate) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Interest rate:</span>
                  <span class="value">{{\$ctrl.selectedAccount.interestRange}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Withholding tax rate:</span>
                  <span class="value">{{\$ctrl.selectedAccount.withholdingTax | rate}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Accrued interest:</span>
                  <span class="value">{{\$ctrl.selectedAccount.accruedInterest | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Related People:</span>
                  <span class="value" ng-repeat="relative in \$ctrl.profile.relatives">
                    [ {{relative.customerNumber || '-'}} ][ {{relative.effectiveName}} ][ {{relative.relation}} ]{{\$last ? '' : ', '}}
                  </span>
                  <span ng-if="!\$ctrl.profile.relatives">-</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.selectedAccount.subtype !== 'SAVINGS'">
                  <span class="key">Related Accounts:</span>
                  <span class="value" ng-repeat="account in \$ctrl.selectedAccount.relatedAccounts">
                    {{account.productNumber}}{{\$last ? '' : ', '}}
                  </span>
                  <span ng-if="!\$ctrl.selectedAccount.relatedAccounts">-</span>
                </div>
                <div class="info-detail">
                  <span class="key">SSS pensioner:</span>
                  <span class="value">
                    {{\$ctrl.sssPensionTargetAccountIds.includes(\$ctrl.selectedAccount.id) | prettyBoolean}}
                  </span>
                </div>
                <div class="info-detail">
                  <span class="key">Last signature upload date:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.lastUpdateSignatureCardOn | prettyDate) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Tax exempted:</span>
                  <span class="value">{{\$ctrl.selectedAccount.taxExempted ? 'Yes' : 'No'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last interest application:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.lastInterestApplication | prettyDateTime) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Dormancy date:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.dormancyDate | prettyDate) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last dormancy charge:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.lastDormancyCharge | prettyDateTime) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last maintaining charge:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.lastMaintainingCharge | prettyDateTime) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Last accrual:</span>
                  <span class="value">{{(\$ctrl.selectedAccount.lastAccrualDate | prettyDateTime) || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Extra number:</span>
                  <span class="value">{{\$ctrl.selectedAccount.extraNumber || '-'}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.isCorporate">
                  <span class="key">Alias:</span>
                  <span class="value">{{\$ctrl.selectedAccount.alias || '-'}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Initial deposit performed:</span>
                  <span class="value">{{\$ctrl.selectedAccount.initialDepositPerformed | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Default interest rate forced:</span>
                  <span class="value">{{\$ctrl.selectedAccount.defaultInterestRateForced | prettyBoolean}}</span>
                </div>
                <hr class="hr-thin-margin">
                <div>
                  <div class="row text-right">
                    <button type="button" class="btn btn-primary" ng-click="\$ctrl.printDetails()">Print
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="owners">
              <table class="table">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>{{\$ctrl.isCorporate ? "Withdrawal limit" : "Type"}}</th>
                  <th ng-if="!\$ctrl.isCorporate">PDIC</th>
                  <th class="signature">Signature</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="owner in \$ctrl.selectedAccount.ownership" ng-if="!\$ctrl.isCorporate || owner.ownershipType === 'SIGNATORY'">
                  <td>
                    <span ng-if="owner.customerId == \$ctrl.profile.id">{{owner.effectiveName}}</span>
                    <a class="link"
                       ng-click="\$ctrl.switchContext(owner)"
                       ng-if="owner.customerId != \$ctrl.profile.id">
                      <span>{{owner.effectiveName}}</span>
                    </a>
                  </td>
                  <td>
                    <span ng-if="!\$ctrl.isCorporate">{{owner.ownershipType | translateEnum:'PRODUCT'}}</span>
                    <span ng-if="\$ctrl.isCorporate && owner.ownershipType === 'SIGNATORY'">{{owner.relative ? (owner.relative.withdrawalLimit | nxCurrency) : ''}}</span>
                  </td>
                  <td ng-if="!\$ctrl.isCorporate">{{\$ctrl.selectedAccount.pdicTypeName}}</td>
                  <td class="signature">
                    <signature-card file-id="owner.signatureFileId" use-icon-button="true"></signature-card>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="tab-pane" id="ata">

              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Enabled:</span>
                  <span class="value">{{\$ctrl.ata.enabled | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Max no of linked accounts:</span>
                  <span class="value">{{\$ctrl.ata.maxRelations}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Allow linking accounts of related CIFs:</span>
                  <span class="value">{{\$ctrl.ata.allowExternalRelations | prettyBoolean}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Transaction triggers:</span>
                  <span class="value" ng-if="!\$ctrl.ata.triggerCommands">-</span>
                  <span class="value" ng-repeat="item in \$ctrl.ata.triggerCommands" ng-if="\$ctrl.ata.triggerCommands">
                    {{ item | startCase }}<span ng-if="!\$last">,</span>
                  </span>
                </div>
                <div class="info-detail">
                  <span class="key">Allowed credit operations:</span>
                  <span class="value" ng-if="!\$ctrl.ata.creditCommands">-</span>
                  <span class="value" ng-repeat="item in \$ctrl.ata.creditCommands" ng-if="\$ctrl.ata.creditCommands">
                    {{ item | startCase }}<span ng-if="!\$last">,</span>
                  </span>
                </div>
                <div class="info-detail">
                  <span class="key">{{ \$ctrl.ataLabels.replenishmentFlag }}:</span>
                  <span class="value">{{(\$ctrl.ata.replenishStrategy !== 'NONE') | prettyBoolean }}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.ata.replenishStrategy !== 'NONE'">
                  <span class="key">{{ \$ctrl.ataLabels.replenishmentStrategy }}:</span>
                  <span class="value">{{\$ctrl.ataReplenishStrategiesMap[\$ctrl.ata.replenishStrategy]}}</span>
                </div>
                <div class="info-detail" ng-if="\$ctrl.ata.replenishStrategy !== 'NONE'">
                  <span class="key">{{ \$ctrl.ataLabels.replenishmentThreshold }}:</span>
                  <span class="value">{{\$ctrl.ata.replenishThreshold | nxCurrency}}</span>
                </div>
              </div>

              <div class="operation-row">
                <button class="btn btn-warning"
                        type="button"
                        command-access="UpdateAccountAutomaticTransferAgreement"
                        ng-click="\$ctrl.editAta()">
                  Edit ATA
                </button>
              </div>

            </div>

            <div class="tab-pane" id="ada">
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Enabled:</span>
                  <span class="value">{{\$ctrl.selectedAccount.automaticDebitAgreementSchedule != null ? 'Yes':'No'}}</span>
                </div>
              </div>
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Automatic debit schedule:</span>
                  <span class="value">{{((\$ctrl.selectedAccount.automaticDebitAgreementSchedule) | prettyEnum) || '-'}}</span>
                </div>
              </div>
              <div class="operation-row">
                <button class="btn btn-warning"
                        type="button"
                        command-access="ConfigureAutomaticDebitAgreement"
                        ng-click="\$ctrl.configAda()">
                  Configure
                </button>
              </div>
            </div>

            <div class="tab-pane" id="sweep" ng-if="\$ctrl.isAutoSweepFacilityEnabled">
              <div class="detail-rows">
                <div class="info-detail">
                  <span class="key">Enabled:</span>
                  <span class="value">{{\$ctrl.sweep.enabled | prettyBoolean}}</span>
                </div>
              </div>
              <div class="detail-rows" ng-if="\$ctrl.sweep.enabled">
                <div class="info-detail">
                  <span class="key">Sweep interval (minutes):</span>
                  <span class="value">{{\$ctrl.sweep.sweepInterval || '-'}}</span>
                </div>
              </div>
              <div class="detail-rows" ng-if="\$ctrl.sweep.enabled">
                <div class="info-detail">
                  <span class="key">Retain maintaining balance:</span>
                  <span class="value">{{\$ctrl.sweep.retainMaintainingBalance | prettyBoolean}}</span>
                </div>
              </div>
              <div class="detail-rows" ng-if="\$ctrl.sweep.enabled">
                <div class="info-detail">
                  <span class="key">Target product number:</span>
                  <span class="value">{{\$ctrl.sweep.targetProductNumber || '-'}}</span>
                </div>
              </div>
              <div class="operation-row">
                <button class="btn btn-warning"
                        type="button"
                        style="margin-left: 0 !important; margin-right: 0 !important;"
                        command-access="ConfigureAutoBalanceSweep"
                        ng-click="\$ctrl.configSweep()"
                        ng-disabled="!\$ctrl.configSweepAvailable()">
                  Configure
                </button>
              </div>
            </div>

            <div class="tab-pane" id="group" ng-if="\$ctrl.selectedAccount.supportsGroup">
              <div ng-if="!\$ctrl.selectedAccount.group" class="operations-row">
                <button
                  class="btn btn-primary"
                  type="button"
                  command-access="AddAccountGroupMember"
                  ng-click="\$ctrl.addToGroup()"
                >
                  Add to Group
                </button>
              </div>
              <div class="detail-rows" ng-if="\$ctrl.selectedAccount.group">
                <div class="info-detail">
                  <span class="key">Group name:</span>
                  <span class="value">{{\$ctrl.selectedAccount.group.name}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Members:</span>
                  <span class="value">{{\$ctrl.selectedAccount.group.accounts.length}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Total Balance:</span>
                  <span class="value">{{\$ctrl.selectedAccount.group.totalBalance | nxCurrency}}</span>
                </div>
                <div class="info-detail">
                  <span class="key">Current Interest Rate:</span>
                  <span class="value">{{\$ctrl.selectedAccount.group.currentInterestRate | rate}}</span>
                </div>
                <div class="info-detail">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Group Accounts</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="member in \$ctrl.selectedAccount.group.accounts">
                      <td>{{member.productNumber}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div ng-if="\$ctrl.selectedAccount.group" class="operation-row">
                <button class="btn btn-danger"
                        type="button"
                        command-access="RemoveAccountGroupMember"
                        ng-click="\$ctrl.removeFromGroup()">
                  <!--Manage<br/>Account Group-->
                  Remove from Group
                </button>
                <button class="btn btn-primary"
                        type="button"
                        ng-click="\$ctrl.showGroupDetails()">
                  View Group Details
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form-section>

    <div class="tab-menu">
      <ul class="nav-tabs">
        <li class="active">
          <a data-target="#cpr_tab_transactions" data-toggle="tab">
            <span>Transaction History</span>
          </a>
        </li>
        <li ng-if="\$ctrl.hasActivePassbook()">
          <a data-target="#cpr_tab_passbook" data-toggle="tab">
            <span>Passbook (No: {{\$ctrl.activePassbook.number}})</span>
          </a>
        </li>
        <li ng-if="\$ctrl.isCheckbookAccount">
          <a data-target="#cpr_tab_checkbook" data-toggle="tab">
            <span>Checkbook</span>
          </a>
        </li>
        <li>
          <a data-target="#cpr_tab_holds" data-toggle="tab">
            <span>Holds</span>
          </a>
        </li>
        <li>
          <a data-target="#cpr_tab_locks" data-toggle="tab">
            <span>Locks</span>
          </a>
        </li>
        <li>
          <a data-target="#note_history" data-toggle="tab">
            <span>Note History</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content" style="overflow: unset">
      <div class="tab-pane active" id="cpr_tab_transactions">
        <form-section class="history">
          <transaction-history
            product="\$ctrl.selectedAccount"
            groups="\$ctrl.groups"
            item="\$ctrl.item"
            product-type="'ACCOUNT'"
            profile="\$ctrl.profile">
            <div>
              <div class="inline-panel__container"
                   ng-repeat="keyValueItem in \$ctrl.keyValueDetails(\$ctrl.item)">
                <label class="inline-panel__label">{{keyValueItem.label}}:</label>
                <p class="inline-panel__value">{{keyValueItem.value}}</p>
              </div>
              <div>
                <span>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item.operationGroup === 'TRANSFER_FUNDS'
                      && \$ctrl.item.operationSubgroup === 'REGULAR'
                      && !\$ctrl.item.attributes['AUTOMATIC_DEBIT']"
                    command-access="AccountTransferToProductRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertInternalTransfer(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item, 'DepositAutomaticDebitPlacementRevert')
                      && \$ctrl.item.operationGroup === 'TRANSFER_FUNDS'
                      && \$ctrl.item.operationSubgroup === 'REGULAR'
                      && \$ctrl.item.attributes['AUTOMATIC_DEBIT']"
                    command-access="DepositAutomaticDebitPlacementRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertAdaPlacement(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item) && \$ctrl.item.operationGroup === 'DEPOSIT_CASH'"
                    command-access="DepositCashToAccountRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertCashDeposit(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item.operationGroup === 'WITHDRAW_CASH'
                      && \$ctrl.item.operationSubgroup !== 'ENCASH_CHECK_ON_US'"
                    command-access="WithdrawAccountFundsByCashRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertCashWithdrawal(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item.operationGroup === 'DEBIT_MEMO'
                      && !['DEBIT_ON_US_CHECK', 'MARK_CLEAR_INWARD_CHECK_ERROR'].includes(\$ctrl.item.operationSubgroup)"
                    command-access="WithdrawAccountFundsByMemoRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertDebitMemo(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item.operationGroup === 'CREDIT_MEMO'
                      && !['TAGGED_MEMO', 'MARK_CLEAR_INWARD_CHECK_ERROR'].includes(\$ctrl.item.operationSubgroup)"
                    command-access="DepositMemoToAccountRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertCreditMemo(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item) && ['DEPOSIT_CHECK', 'DEPOSIT_CUTOFF_CHECK'].includes(\$ctrl.item.operationGroup)"
                    command-access="DepositCheckToAccountRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertCheckDeposit(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item.operationGroup === 'WITHDRAW_CHECK'
                      && \$ctrl.item.operationSubgroup !== 'CLEAR_INWARD_CHECK'"
                    command-access="WithdrawAccountFundsByCheckRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertCheckWithdrawal(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item
                      && \$ctrl.revertCreditOnUsCheckEnabled(\$ctrl.item)"
                    command-access="CreditOnUsCheckRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertCreditOnUsCheck(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && \$ctrl.item.operationGroup === 'WITHDRAW_CASH'
                      && \$ctrl.item.operationSubgroup === 'ENCASH_CHECK_ON_US'
                      && \$ctrl.item.checkId"
                    command-access="EncashOnUsCheckRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertEncashOnUsCheck(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item)
                      && ['EXTERNAL_TRANSFER_OUTGOING_PESONET', 'EXTERNAL_TRANSFER_OUTGOING_PESONET_INTERNATIONAL'].includes(\$ctrl.item.targetCode)"
                    command-access="PesonetOverTheCounterTransferRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertPesonetTransfer(\$ctrl.item)">
                    Revert
                  </button>
                  <button
                    type="button"
                    ng-if="\$ctrl.revertAllowed(\$ctrl.item, 'PayLoanByAutomaticDebitRevert')
                      && \$ctrl.item.commandTypeName === 'PayLoanByAutomaticDebit'
                      && \$ctrl.item.operationSubgroup === 'LOAN_PAYMENT'"
                    command-access="PayLoanByAutomaticDebitRevert"
                    class="btn btn-danger"
                    ng-click="\$ctrl.revertAdaPayment(\$ctrl.item)">
                    Revert
                  </button>
                </span>
                <button
                  type="button"
                  ng-if="\$ctrl.item.operationGroup === 'CLEAR_CHECK'
                    && (['PENDING', 'PROCESSED'].includes(\$ctrl.item.status))
                    && !\$ctrl.hasReturnCheckOperation(\$ctrl.item)"
                  command-access="ReturnAccountCheck"
                  class="btn btn-danger"
                  ng-click="\$ctrl.returnCheck(\$ctrl.item)">
                  Return check
                </button>
                <button type="button" class="btn btn-primary"
                        ng-if="\$ctrl.isValidationSlipActive(\$ctrl.item) && \$ctrl.isValidationSlipSupported(\$ctrl.item)"
                        ng-click="\$ctrl.showPrint(\$ctrl.item)">
                  Print validation
                </button>
                <button type="button" class="btn btn-primary"
                        ng-if="\$ctrl.isValidationSlipActive && \$ctrl.isBatchValidationSlipSupported(\$ctrl.item)"
                        ng-click="\$ctrl.showBatchPrint(\$ctrl.item)">
                  Print batch validation
                </button>
              </div>
              <section>
                <button
                  type="button"
                  ng-if="\$ctrl.revertAllowed(\$ctrl.item, 'CancelInwardCheck') && \$ctrl.canRevertInwardCheck(\$ctrl.item)"
                  command-access="CancelInwardCheck"
                  class="btn btn-danger"
                  ng-click="\$ctrl.revertInwardCheck(\$ctrl.item)">
                  Revert check
                </button>
                <button
                  command-access="UpdateCheckNumber"
                  type="button"
                  class="btn btn-warning"
                  ng-if="\$ctrl.canEditCheckNumber(\$ctrl.item)"
                  ng-click="\$ctrl.editCheckNumber(\$ctrl.item)">
                  Edit check number
                </button>
              </section>
            </div>
          </transaction-history>
        </form-section>
      </div>

      <div ng-if="\$ctrl.hasActivePassbook()" class="passbook tab-pane" id="cpr_tab_passbook">
        <passbook
          renderable-prints="[{'code':'DEPOSIT_ACCOUNT_PASSBOOK'}]"
          product="\$ctrl.selectedAccount"
          customer-id="\$ctrl.profile.id"
          product-group="'DEPOSIT_ACCOUNT'"
          passbook-obj="\$ctrl.activePassbook">
        </passbook>
      </div>
      <div ng-if="\$ctrl.isCheckbookAccount" class="checkbook tab-pane" id="cpr_tab_checkbook">
        <checkbook-details
          product="\$ctrl.selectedAccount"
          customer-id="\$ctrl.selectedAccount.customerId">
        </checkbook-details>
      </div>

      <div id="cpr_tab_holds" class="holds tab-pane">
        <product-holds product="\$ctrl.selectedAccount"></product-holds>
      </div>

      <div id="cpr_tab_locks" class="locks tab-pane">
        <product-locks ng-if="\$ctrl.selectedAccount" product="\$ctrl.selectedAccount"></product-locks>
      </div>

      <div class="tab-pane" id="note_history">
        <note-history product-id="\$ctrl.selectedAccount.id"
                      product-type="'ACCOUNT'"></note-history>
      </div>

    </div>
  </div>
</section>

<modal on-api-ready="\$ctrl.onAccountGroupModalApiReady">
  <modal-header><h2>Group Details</h2></modal-header>
  <modal-body>
    <account-group-members account-group="\$ctrl.selectedAccountGroup"></account-group-members>
  </modal-body>
</modal>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/customer-accounts.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;